const axios = require('axios');

class ReadyYetService {
  getAngularStatus() {
    return axios.get('/api/statuses/angular').then(res => res.data);
  }
}

const readyYetService = new ReadyYetService();

export default readyYetService;